import { gql } from '@apollo/client';

export const ADD_UPDATE_DOCUMENT_CLAUSE = gql`
  mutation addOrUpdateDocumentClause($input: DocumentClauseItemInput) {
    addOrUpdateDocumentClause(input: $input) {
      commandId
    }
  }
`;
